import FilePickerActionsPanelViewState from '../../store/schema/FilePickerActionsPanelViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('updateSaveUserChoice')(function updateSaveUserChoice(
    viewState: FilePickerActionsPanelViewState,
    shouldSave: boolean
) {
    viewState.saveUserChoice = shouldSave;
});
